<template>
  <div>
    <div class="over_layout">
      <section class="group">
        <div class="wrapper">
          <div class="slider_resume">
            <div class="fix_bg">
              <img src="/vue/images/cv-slider/cv-bg.png">
            </div>
            <div class="container_head_cv">
              <div class="active">
                <img src="/vue/images/cv-slider/hand3.png">
              </div>
              <div>
                <img src="/vue/images/cv-slider/hand5.png">
              </div>
              <div>
                <img src="/vue/images/cv-slider/hand7.png">
              </div>
              <div>
                <img src="/vue/images/cv-slider/hand.png">
              </div>
              <div>
                <img src="/vue/images/cv-slider/hand2.png">
              </div>
              <div>
                <img src="/vue/images/cv-slider/hand6.png">
              </div>
              <div>
                <img src="/vue/images/cv-slider/hand8.png">
              </div>
              <div>
                <img src="/vue/images/cv-slider/hand9.png">
              </div>
            </div>
            <div class="container_head_cv_mob">
              <div class="active">
                <img src="/vue/images/cv-slider/mobcv-03.png">
              </div>
              <div>
                <img src="/vue/images/cv-slider/mobcv-05.png">
              </div>
              <div>
                <img src="/vue/images/cv-slider/mobcv-07.png">
              </div>
              <div>
                <img src="/vue/images/cv-slider/mobcv-08.png">
              </div>
              <div>
                <img src="/vue/images/cv-slider/mobcv-09.png">
              </div>
              <div>
                <img src="/vue/images/cv-slider/mobcv-02.png">
              </div>
              <div>
                <img src="/vue/images/cv-slider/mobcv-06.png">
              </div>
              <div>
                <img src="/vue/images/cv-slider/mobcv-01.png">
              </div>
            </div>
          </div>
          <div class="block_left">
            <div class="title_block">
              {{ $store.getters.t('CV_in') }}
              <span>5</span>
              {{ $store.getters.t('minutes') }}
            </div>
            <div class="block_under_title">{{ $store.getters.t('Just_3_simple_steps') }}</div>
            <ul>
              <li @click="openPaymentModal()" class="c-p">
                <div class="icon_1"></div>
                <span>{{ $store.getters.t('select') }}</span>
              </li>
              <li>
                <div class="icon_2"></div>
                <span>{{ $store.getters.t('edit') }}</span>
              </li>
              <li>
                <div class="icon_3"></div>
                <span>{{ $store.getters.t('download') }}</span>
              </li>
            </ul>
            <div class="add_circle" data-v-step="1"  @click="openPaymentModal()"></div>
          </div>
          <div class="scroll_two">
            <a
                class="yakr_bt"
                @click="routerHashPush"
            ></a>
          </div>
        </div>
      </section>
      <section class="create_your_resume" id="two_section">
        <div class="wrapper">
          <div class="section_title">
            <div class="light_inf_icon"></div>
            <h1>{{ $store.getters.t('Create_your_resume_right_now') }}</h1>
          </div>
          <div class="text_type">{{ $store.getters.t('Create_your_resume_large_text') }}</div>
          <div class="numbers_block">
            <ul>
              <li>
                <div class="number">
                  <span class="counter_number">7</span>
                </div>
                <p>{{ $store.getters.t('resume') }}</p>
              </li>
              <li>
                <div class="number">
                  <span class="counter_number">2k</span>
                </div>
                <p>{{ $store.getters.t('created') }}</p>
              </li>
              <li>
                <div class="number">
                  <span class="counter_number">21</span>
                </div>
                <p>{{ $store.getters.t('blog') }}</p>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <section class="bestsellers">
        <div class="wrapper">
          <div class="all_title_block left_title_block">
            <div class="title_block">
              <div></div>
              <span>{{ $store.getters.t('bestsellers') }}</span>
            </div>
          </div>
        </div>
        <div class="bestsellers_block">
          <div class="wrapper">
            <div class="all_block_add">
              <template v-if="!owl && !owlImages">
                <div class="blocks">
                  <div class="block">
                    <router-link :to="{ name:'cv-create-u-2',lang: $store.getters.locale }">
                      <img src="/vue/images/cv_img_2.png">
                    </router-link>
                  </div>
                  <div class="block">
                    <router-link :to="{ name:'cv-create-p-2',lang: $store.getters.locale }">
                      <img src="/vue/images/cv_img_3.png">
                    </router-link>
                  </div>
                  <div class="block">
                    <router-link :to="{ name:'cv-create-u-1',lang: $store.getters.locale }">
                      <img src="/vue/images/cv_img_4.png">
                    </router-link>
                  </div>
                </div>
              </template>
              <template v-else>
                <carousel
                    class="blocks"
                    :margin="10"
                    :stagePadding="20"
                    :items="3"
                    :loop="true"
                    :nav="false"
                    :dots="true"
                    :responsive="{0: {items: 1 }, 500: {items: 2 },768: {items: 3 }}"
                >
                  <div class="block">
                    <img src="/vue/images/cv_img_2.png">
                  </div>
                  <div class="block">
                    <img src="/vue/images/cv_img_3.png">
                  </div>
                  <div class="block">
                    <img src="/vue/images/cv_img_4.png">
                  </div>
                </carousel>
              </template>
              <div class="block_add">
                <div class="add_circle" @click="openPaymentModal()"></div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <active-posts :posts="active_posts"></active-posts>
      <section class="our_advantages">
        <div class="wrapper">
          <div class="all_title_block left_title_block">
            <div class="title_block">
              <div></div>
              <span>{{ $store.getters.t('Our_advice') }}</span>
            </div>
          </div>
        </div>
        <div class="wrapper wrapper_inner">
          <template v-if="!owl">
            <div class="block">
              <template v-for="( advice, index) in advices">
                <div
                    v-bind:class="[index % 2 == 0 ? 'right_part' : 'left_part']"
                    :key="advice.at_id"
                >
                  <div class="img">
                    <img :src="advice.photo" :alt="advice.photo_title">
                  </div>
                  <div class="all_text">
                    <div class="text">
                      <div class="name" :title="advice.title">{{ advice.name }}</div>
                      <p>{{ advice.content }}</p>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </template>
          <template v-else>
            <carousel
                class="block"
                :margin="10"
                :stagePadding="10"
                :items="1"
                :loop="true"
                :autoHeight="true"
                :nav="false"
                :dots="true"
            >
              <template v-for="( advice, index) in advices">
                <div
                    v-bind:class="[index % 2 == 0 ? 'right_part' : 'left_part']"
                    :key="advice.at_id"
                >
                  <div class="img">
                    <img :src="advice.photo" :title="advice.photo_title">
                  </div>
                  <div class="all_text">
                    <div class="text">
                      <div class="name" :title="advice.title">{{ advice.name }}</div>
                      <p>{{ advice.content }}</p>
                    </div>
                  </div>
                </div>
              </template>
            </carousel>
          </template>
        </div>
      </section>


      <section class="feedback">
        <div class="wrapper">
          <div class="all_title_block right_title_block">
            <div class="title_block">
              <span>{{ $store.getters.t('our_feedback') }}</span>
              <div></div>
            </div>
          </div>
        </div>

        <div id="feedback_block" class="feedback_block" ref="feedback_block">
          <!--<vue-scroll ref="feedback_block_scroll" :ops="ops"  @handle-scroll="handleScroll">-->
          <div class="wrapper clearfix">
            <div
                v-for="( feedback, index) in feedbacks"
                :key="feedback.id"
                v-bind:class="[ index % 2 === 0 ? 'left_block block clearfix' : 'right_block block clearfix']"
            >
              <template v-if="index % 2 === 0">
                <div class="img">
                  <img :src="feedback.user.avatar ? feedback.user.avatar.image : feedback.user.photo">
                </div>
                <div class="message_name">
                  <div class="message">{{ feedback.comment }}</div>
                  <div class="name">
                    {{ ( feedback.user.name || '') + ' ' + (feedback.user.surname || '' ) }}
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="message_name">
                  <div class="message">{{ feedback.comment }}</div>
                  <div class="name">
                    {{ ( feedback.user.name || '' ) + ' ' + ( feedback.user.surname || '' ) }}
                  </div>
                </div>
                <div class="img">
                  <img :src="feedback.user.avatar ? feedback.user.avatar.image : feedback.user.photo">
                </div>
              </template>
            </div>
          </div>
          <!--</vue-scroll>-->
        </div>

        <div class="add_message">
          <div class="wrapper">
            <template v-if="$store.getters.user">
              <form v-on:submit.prevent="sendComment">
                <input
                    v-if="!($store.getters.user.name || '').trim()"
                    class="inp_type"
                    v-validate="'required|min:3'"
                    :class="errors.first('commenter_name') ? 'invalid' : ''"
                    :placeholder="$store.getters.t('name')"
                    name="commenter_name"
                    type="text"
                    required
                >
                <input
                    v-if="!($store.getters.user.surname || '').trim()"
                    class="inp_type"
                    v-validate="'required|min:3'"
                    :class="errors.first('commenter_surname') ? 'invalid' : ''"
                    :placeholder="$store.getters.t('surname')"
                    name="commenter_surname"
                    type="text"
                    required
                >
                <textarea
                    placeholder="Напишите сообщения"
                    name="comment"
                    v-model="comment"
                    :class="errors.first('comment') ? 'invalid' : ''"
                    v-validate="'required|min:20'"
                    required
                ></textarea>
                <input class="add_send" type="submit" :value="$store.getters.t('send')">
              </form>
            </template>
            <template v-else>
              <form v-on:submit.prevent>
                <textarea placeholder="Напишите сообщения" v-model="comment"></textarea>
                <input
                    class="add_send"
                    type="submit"
                    :value="$store.getters.t('send')"
                    v-on:click="$store.commit('loginModal', true )"
                >
              </form>
            </template>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
  import ActivePosts from "../widgets/ActivePosts.vue";
  import carousel from "vue-owl-carousel";

  export default {
    name: 'Home',
    components: {
      "active-posts": ActivePosts,
      carousel: carousel,
    },
    data() {
      return {
        owlImages: false,
        owl: false,
        advices: {},
        active_posts: {},
        feedbacks: {},
        comment: "",
        ops: {
          vuescroll: {
            wheelScrollDuration: 300,
            wheelDirectionReverse: false,
          },
          scrollPanel: {
            scrollingY: false,
          },
          rail: {},
          bar: {
            showDelay: 500,
            onlyShowBarOnScroll: true,
            keepShow: false,
            background: '#c1c1c1',
            opacity: 1,
            specifyBorderRadius: false,
            minSize: 0,
            size: '5px',
          },
          status: 'top'
        }
      };
    },
    watch: {
      $route(to, from) {
        if (to.params.lang != from.params.lang) {
          this.$parent.getData().then(changed => {
            if (changed) {
              this.getHomeData();
            }
          });
        }
      }
    },
    beforeMount() {
      window.addEventListener("resize", () => {
        this.owlCarusel(true);
      });
    },
    mounted() {
      this.$parent.getData().then(changed => {
        if (changed) {
          if (this.$store.getters.authUser && this.$Cookies.get("LRU")) {
            this.$router.push(this.$Cookies.get("LRU"));
            this.$Cookies.remove("LRU");
          }
          this.getHomeData();
          if (this.$route.query["forget-password"]) {
            if (!this.$store.getters.authUser) {
              this.$parent.forgetPassword(this.$route.query["forget-password"]);
            } else {
              this.$router.push("home");
            }
          }
        }
      });
      this.resumeSlide();

    },
    methods: {
      // handleScroll(vertical) {
      //   if (vertical.process === 1 && this.ops.status === 'bottom') {
      //     this.$parent.$parent.$parent.$parent.ops.scrollPanel.scrollingY = true;
      //   }
      //
      //   if (vertical.process === 0 && this.ops.status === 'bottom') {
      //     this.ops.scrollPanel.scrollingY = false;
      //     this.$parent.$parent.$parent.$parent.ops.scrollPanel.scrollingY = true;
      //     this.ops.status = 'top';
      //   }
      // },
      routerHashPush() {
        this.$parent.$parent.$parent.$parent.$refs['body_scroll'].scrollTo(
          {
            y: window.innerHeight
          },
          500,
          "easeInQuad"
        );
      },
      openPaymentModal() {
        this.$store.commit("paymentModal", true);
        this.$tours['myTour'].nextStep();
      },
      getHomeData() {
        this.$http({
          method: "get",
          url: `/api/home-page`
        }).then(res => {
          this.active_posts = res.data.active_posts;
          this.advices = res.data.advices;
          this.feedbacks = res.data.feedbacks;
          this.owlCarusel();
        });
      },
      sendComment(form) {
        var formData = new FormData(form.target);
        if (!this.errors.items.length) {
          this.$http({
            method: "post",
            url: `/api/feedback/send`,
            data: formData
          })
            .then(res => {
              console.log(res);
              if (res.data.success) {
                if (res.data.user !== false) {
                  this.$store.commit("user", res.data.user);
                }
                this.$store.commit("newMessage", {
                  show: true,
                 type: "success",
                  messageTitle: this.$store.getters.t("success"),
                  message: this.$store.getters.t("commit success")
                });
                this.comment = "";
                setTimeout(() => {
                  form.target
                    .getElementsByTagName("textarea")[0]
                    .classList.remove("invalid");
                }, 100);
              } else {
                this.$store.commit("newMessage", {
                  show: true,
                  type: "error",
                  messageTitle: this.$store.getters.t("error"),
                  message: this.$store.getters.t("invalid data")
                });
              }
            })
            .catch(err => {
              console.log(err);
            });
        }
      },
      resumeSlide(time = 3000) {
        let images = document.getElementsByClassName("container_head_cv")[0]
          .children;
        let mobImages = document.getElementsByClassName(
          "container_head_cv_mob"
        )[0].children;
        if (images.length) {
          let slide = false;
          setInterval(() => {
            var responsiveImages = images;
            if (window.innerWidth < 501) {
              responsiveImages = mobImages;
            }
            for (let i = 0; i < responsiveImages.length; i++) {
              if (responsiveImages[i].classList.contains("active")) {
                responsiveImages[i].classList.remove("active");
                slide = true;
                if (i == responsiveImages.length - 1 && slide) {
                  responsiveImages[0].classList.add("active");
                }
                continue;
              }
              if (slide) {
                responsiveImages[i].classList.add("active");
                slide = false;
              }
            }
          }, time);
        }
      },
      owlCarusel(resize = false) {
        this.owl = window.innerWidth < 768;
        if (this.owl && !resize) {
          this.owlImages = true;
          this.owl = false;
          setTimeout(() => {
            this.owl = true;
          }, 400);
        }
      },

      handleActivate(vm, refreshDom) {
        console.log(vm, refreshDom, 'handleActivate');
      },
      handleStart(vm, refreshDom, done) {
        console.log(vm, refreshDom, 'handleStart');
        seTimeout(() => {
          done(); // load finished
        }, 2000);
      },
      handleBeforeDeactivate(vm, refreshDom, done) {
        console.log(vm, refreshDom, 'handleBeforeDeactivate');
        done();
      },
      handleDeactivate(vm, refreshDom) {
        console.log(vm, refreshDom, 'handleDeactivate');
      }
    }
  };
</script>
<style scoped>
  .c-p {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// resources/js/components/pages/Home.vue